import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {PriceBookLineContainerModel} from '../../../../../../models/aggregates/erp/price-book';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class PriceBookLineService extends BaseApiTemplateService<PriceBookLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-line';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-line';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-line';
    this.httpClient = http;
  }

}


